import { useAcl } from "@/api/auth/useAcl";
var allowlists = {
    newHubPartners: [
        "SvAiK8PA",
        "Qlvm1vPA",
        "KJNS6kPA",
        "sJrUixPA",
        "vXfVgrPA",
        "uFLRmmPA",
        "rHwLIGPA",
        "srMmqpPA",
        "5HEUDkPA",
        "2JDZ0hPA",
        "mkeCXZPA",
        "LsNRfSPA",
        "XuWWScPA",
        "VP0ptqPA",
        "sJrUixPA",
        "K6DVyXPA",
        "y16WHePA",
        "F3UBL9PA",
        "RYGuETPA",
        "jbVmnNPA",
        "nKXLPlPA",
        "xlQPPePA",
        "rnhrnqPA",
        "shlVMHPA",
        "z2qXfJPA",
        "VEXn8JPA",
        "9YD4l2PA",
        "cdmBraPA",
        "3nK2RfPA",
        "aC8cqrPA",
        "IGVgYSPA",
        "LiM3SXPA",
        "6e7Z8GPA",
        "eUixdSPA",
        "z19ri4PA",
        "JDv0gHPA",
        "BLYHeePA",
        "xDWnSlPA",
        "jDSCbJPA",
        "wqCmP2PA",
        "W6J7cMPA",
        "HuYlBjPA",
        "FsauuZPA",
        "ORxTHRPA",
        "Er6VACPA",
        "2oDwvBPA",
        "oQTaPbPA",
        "XnxZRTPA",
        "mAmciAPA",
        "JT0hXQPA",
        "54HwsZPA",
        "rPm16mPA",
        "PDsoh4PA",
        "6MKi1UPA",
        "WZ0UcaPA",
        "DPiM0ePA",
        "ehlh1uPA",
        "C9M0MkPA",
        "NhWH5UPA",
        "WokHLhPA",
        "ZNmRUbPA",
        "pRfnd2PA",
        "DB2ojNPA",
        "KwtWRIPA",
        "CyEjaWPA",
        "RskrW8PA",
        "li5GmnPA",
        "WDsV8zPA",
        "78BK4cPA",
        "M2t1wmPA",
        "UpSIy2PA",
        "mr20GxPA",
        "G40NnoPA",
        "1sA3v9PA",
        "RlVfu4PA",
        "39ed4ZPA",
        "b10O9yPA",
        "6FtguzPA",
        "uiPX3jPA",
        "uylkJYPA",
        "kterSxPA",
        "XtF9OFPA",
        "wFXP0tPA",
        "j0LxQzPA",
        "xns9YRPA",
        "BXPrc4PA",
        "HixHDPPA",
        "9ofv8uPA",
        "mxoKWIPA",
        "iinLZ4PA",
        "UoqOpxPA",
        "l0r8WdPA",
        "zPGcIbPA",
        "gnWJBiPA",
        "a2MiiFPA",
        "0IB3VPPA",
        "4cnKtqPA",
        "YwrklJPA",
        "9AZKtqPA",
        "lyhMIIPA",
        "FOvmmfPA",
        "ZN65H1PA",
        "o35Vj9PA",
        "a3GPkEPA",
        "y9PPo9PA",
        "SnkqXGPA",
        "GguXNjPA",
        "HiyRQOPA",
        "PPl7RSPA",
        "eHxz0PPA",
        "6p1GECPA",
        "u71yABPA",
        "shhi1yPA",
        "qFTgOtPA",
        "71vEuhPA",
        "incC1lPA",
        "f52FobPA",
        "ISKSdDPA",
        "WB0bq2PA",
        "vo0dIjPA",
        "sgl4QxPA",
        "sC675vPA",
        "IJluX1PA",
        "Xrd8RFPA",
        "CJX01rPA",
        "2pFZc9PA",
        "stgWRjPA",
        "uks9zKPA",
        "GRTDb7PA",
        "CHbgPePA",
        "YjrERkPA",
        "cPbKAwPA",
        "RJilfFPA",
        "E7qlilPA",
        "wgGnkPPA",
        "UzXHmxPA",
        "ZKxY1sPA",
        "BV3JYkPA",
        "B8AFQ9PA",
        "RqNVAIPA",
        "Va7T6tPA",
        "aS0ZbWPA",
        "zxT8czPA",
        "hOLuzAPA",
        "C7CPtjPA",
        "cydpRsPA",
        "F2MmQ2PA",
        "YlZ27dPA",
        "35VROsPA",
        "VfBX5iPA",
        "LixrLvPA",
        "jKVKwEPA",
        "55fMS5PA",
        "eHqGPdPA",
        "LYVJiQPA",
        "iMRBd1PA",
        "ZBXcVAPA",
        "7SD2lvPA",
        "GtJSeMPA",
        "JuvbXPPA",
        "DQZcyYPA",
        "5o16HnPA",
        "QUPnCfPA",
        "3vv9TNPA",
        "WZs76wPA",
        "kFPv6HPA",
        "IwC4wSPA",
        "ul70jGPA",
        "cV6AonPA",
        "fvxvCjPA",
        "K9V7UjPA",
        "fZDhzyPA",
        "6vvfNxPA",
        "o0nQcXPA",
        "5xZaPePA",
        "dVoyNhPA",
        "n8HOrLPA",
        "W3qKbnPA",
        "GVjAUVPA",
        "Rn0PyTPA",
        "oO5jISPA",
        "dq1pRHPA",
        "bNBu7rPA",
        "2oKvG4PA",
        "On8VVMPA",
        "QO58gYPA",
        "EIPG0aPA",
        "SIH1ayPA",
        "AR889aPA",
        "p177cCPA",
        "GAjpiJPA",
        "Wj8AE1PA",
        "dGB3PEPA",
        "iy3oIyPA",
        "8RCV5RPA",
        "jkOnvaPA",
        "ZtDMlSPA",
        "dbD34wPA",
        "2Loi7QPA",
        "y6bJzrPA",
        "1xOcN8PA",
        "Y7XmvXPA",
        "Q14t1rPA",
        "hxxqxLPA",
        "OgmkVzPA",
        "i0TjY2PA",
        "i7qVKYPA",
        "RiN0XgPA",
        "GJajLGPA",
        "40krNkPA",
        "Z5zHuZPA",
        "TOeu0GPA",
        "JSBIsdPA",
        "TvJbvHPA",
        "46C3maPA",
        "xvlRJxPA",
        "l6xYgyPA",
        "Msq10DPA",
        "VeDg3qPA",
        "PD2aQCPA",
        "BsvNPzPA",
        "cePkN9PA",
        "BCtiAYPA",
        "MprhHiPA",
        "7usMKuPA",
        "FaWaM1PA",
        "3wYMDlPA",
        "NzBw7yPA",
        "CXmrLuPA",
        "H2scGJPA",
        "04VTAcPA",
        "1uQMjIPA",
        "SUIXCOPA",
        "8sM6c8PA",
        "jsQ01lPA",
        "ItJN6TPA",
        "bajekyPA",
        "qH9o1JPA",
        "WvWlVoPA",
        "qV90DQPA",
        "MAZVPkPA",
        "cIpmJrPA",
        "Sx1aQMPA",
        "GANBMsPA",
        "oyK1JuPA",
        "mM5p3HPA",
        "2q7SB3PA",
        "1dPQuOPA",
        "ByX4OePA",
        "Al5wKePA",
        "vcxwujPA",
        "gJqKiPPA",
        "afPJKRPA",
        "DY4qfsPA",
        "QjiRUtPA",
        "BEYnAzPA",
        "ziGCYcPA",
        "FfFHdtPA",
        "GBBwlOPA",
        "GnuZElPA",
        "E3f4EePA",
        "h2oTw3PA",
        "OEDX7SPA",
        "d6kZIYPA",
        "CyjiYUPA",
        "fYIeZvPA",
        "42QMC4PA",
        "Dhc25rPA",
        "V16OIqPA",
        "omlQnNPA",
        "xX1hMxPA",
        "EYsZdMPA",
        "IZadzVPA",
        "FpSxJTPA",
        "81uJRwPA",
        "B5slSsPA",
        "BQ25qVPA",
        "7HOA6pPA",
        "D6DZCvPA",
        "sR2Q3FPA",
        "mMT6TKPA",
        "hOE9k5PA",
        "gAtbpOPA",
        "M9ydoHPA",
        "hZERBEPA",
        "AARyamPA",
        "xui6LEPA",
        "FK3PY8PA",
        "AD0ArQPA",
        "C3MzgOPA",
        "lDqNgdPA",
        "0N1RwjPA",
        "w3Wh4aPA",
        "weNpWIPA",
        "YknKGmPA",
        "cm4qlHPA",
        "zc70tdPA",
        "c1Iw0tPA",
        "rcCOYqPA",
        "rcmukfPA",
        "7a81D2PA",
        "ehE37SPA",
        "XurYdVPA",
        "u0LHPxPA",
        "i2IxrYPA",
        "7aKCyKPA",
        "ur20NLPA",
        "rPyMvRPA",
        "Tju9EoPA",
        "UHeFdsPA",
        "GglOonPA",
        "4GmaQXPA",
        "2PkfccPA",
        "YXgYJJPA",
        "F9wqGfPA",
        "TJ6OUrPA",
        "kFRLDKPA",
        "37OP7jPA",
        "uTFsXrPA",
        "R4714rPA",
        "GYQiDpPA",
        "ggDAXZPA",
        "SuZ2wqPA",
        "tZUZSvPA",
        "XSDQctPA",
        "nkwhEoPA",
        "3j8TENPA",
        "3G2PWYPA",
        "XKtV3WPA",
        "BvaxKOPA",
        "pvlYpNPA",
        "oLmrsxPA",
        "hcJUBwPA",
        "rCEIvoPA",
        "moTgzXPA",
        "hOwgAVPA",
        "WbYuxQPA",
        "rZsucgPA",
        "jBqMtnPA",
        "sv0NexPA",
        "xVO2I8PA",
        "hyDfGFPA",
        "4uvg8ZPA",
        "X9pI7VPA",
        "0eloXJPA",
        "bVFjx1PA",
        "rYCPCUPA",
        "qWY0K9PA",
        "z2EiEOPA",
        "RKkBIYPA",
        "7L93SDPA",
        "VEmbjIPA",
        "9KDO4XPA",
        "A98KXhPA",
        "4CWYfPPA",
        "D0NNUxPA",
        "I2o9naPA",
        "EHvuJWPA",
        "YVBLG7PA",
        "ZvYc8APA",
        "8klSCRPA",
        "2EmmcOPA",
        "IapGChPA",
        "Kg4vHjPA",
        "D5O5PoPA",
        "pey7ilPA",
        "Wbqsg8PA",
        "pxC49cPA",
        "NK2HpiPA",
        "4eeNssPA",
        "KkVr5mPA",
        "Kbuki4PA",
        "Y5hE3yPA",
        "GdkNVsPA",
        "Yq78AsPA",
        "ovYe8lPA",
        "X3FYpgPA",
        "DhwEcpPA",
        "eZgK6gPA",
        "NFv0v6PA",
        "CR9CDIPA",
        "ANQiqAPA",
        "Si7TU4PA",
        "LR7vUMPA",
        "hTniPiPA",
        "hGwBHsPA",
        "QlALeMPA",
        "ZE3Gk9PA",
        "nQlGqCPA",
        "gpl2KaPA",
        "3r8FfkPA",
        "H8ip1zPA",
        "oD2n64PA",
        "20eR3PPA",
        "ghsboWPA",
        "1l1WrwPA",
        "J1zDjpPA",
        "JHrHRaPA",
        "4CW8B4PA",
        "QIivzhPA",
        "nIBRzHPA",
        "LPNGMUPA",
        "MeyzJgPA",
        "Mhmm84PA",
        "XsITOPPA",
        "tLKFjEPA",
        "811r89PA",
        "6SoavgPA",
        "W096JXPA",
        "7lvZRMPA",
        "VDPBnIPA",
        "iRGHVDPA",
        "KnIJBiPA",
        "NY6fdpPA",
        "KLizzDPA",
        "l9yBW4PA",
        "wuJz3kPA",
        "2bGMzcPA",
        "4EF2ifPA",
        "WuMVtoPA",
        "2eHIHfPA",
        "iMT86UPA",
        "6scF0xPA",
        "1ppPCfPA",
        "zm0dOePA",
        "77UpDDPA",
        "Y56yG1PA",
        "QmijZ1PA",
        "t94o8DPA",
        "9K0803PA",
        "S9JSliPA",
        "LcgcDgPA",
        "DGESntPA",
        "oraMDRPA",
        "5Zxli7PA",
        "7uqptQPA",
        "TNLe8bPA",
        "oHk40EPA",
        "V3wc38PA",
        "7KFk99PA",
        "CkwTH2PA",
    ],
    integratedOnboarding: [
        // "CmfFRDPA", // 360dialog staging
        "3A99H5PA",
        "1HrOdjPA",
        "uRD6afPA",
        "CON5A9PA",
        // "yhkzyzPA", // loop26
        "7uqptQPA",
        "oWSmVePA",
        "ATh3hUPA",
        "g555XePA",
        // "XtF9OFPA", // Respond.io
        "K6DVyXPA",
        "BEBD6pPA",
        "huCvMmPA",
        "Tuk0tFPA",
        "xvlRJxPA",
        "5Zxli7PA",
        "EWcCEUPA",
        "MTRBnQPA",
        "gWL8uXPA",
        "d1wNqWPA",
        "vNKb61PA",
        "5lzSJ0PA",
        "QW0d3NPA",
        "nGW3H5PA",
        "8gDDIDPA",
        "FGnmxgPA",
        "irFklqPA",
        "xMfdllPA",
        "DwXAvePA",
        "U5ylW4PA",
        "ickmk2PA",
        "1OyuqDPA",
        "JJu1XbPA",
        "RTJ7L0PA",
        "UfdIklPA",
        "aFV7UKPA",
        "csdGwyPA", // Dealerdesk
    ],
    liveSupport: [
        // after adding new partner to this table, add it also to https://app.hubspot.com/chatflows/508063/edit/live-chat/5792211/target/bot
        "SvAiK8PA",
        "sJrUixPA",
        "KJNS6kPA",
        "Qlvm1vPA",
    ],
    partnerEmbedded: [
        //staging and testing
        "CmfFRDPA",
        "bRVwbQPA",
        // 360dialog direct clients
        "SvAiK8PA",
        "sJrUixPA",
        "KJNS6kPA",
        "Qlvm1vPA",
        "uFLRmmPA",
        // enterprise
        "81pvuJPA",
        "HTJPLuPA",
        // partners
        "7KFk99PA",
        "csdGwyPA",
        "drCSjPPA",
        "plHwVcPA",
        "SWrcuzPA",
        "DfLbUMPA",
        "IOoehFPA",
        "PwlGKrPA",
        "p3arnmPA",
        "AHkrzZPA",
        "frnlL3PA",
        "5nmFt8PA",
        "irFklqPA",
        "5urmEBPA",
        "0U7Q4sPA",
        "0MiLGHPA",
        "DIe6WEPA",
        "AXCt2yPA",
        "XaOFbqPA",
        "gbzMbKPA",
        "OTNIv7PA",
        "tgAe8PPA",
        "yHanHbPA",
        "rKRgFhPA",
        "x6yeLmPA",
        "U5ylW4PA",
        "CXN8ODPA",
        "z1ZbMsPA",
        "hpUPRUPA",
        "0cQ7xqPA",
        "eNecjTPA",
        "1OyuqDPA",
        "wByN4mPA",
        "zrhNLNPA",
        "UUSd78PA",
        "s0CbwUPA",
        "V01LKzPA",
        "1QcGcbPA",
        "33V47sPA",
        "oWSmVePA",
        "HJI1ukPA",
        "7baX2dPA",
        "ilzg9lPA",
        "5A9UYzPA",
        "0SATWQPA",
        "nBXc8NPA",
        "FUEVMZPA",
        "VFZMpTPA",
        "Nog49UPA",
        "vNKb61PA",
        "1mV64JPA",
        "iDtgTpPA",
        "HWkDuMPA",
        "89Suo5PA",
        "1EmtUTPA",
        "MTRBnQPA",
        "dWH8DlPA",
        "yiuFCXPA",
        "QO58gYPA",
        "X9pI7VPA",
        "UjX7KwPA",
        "X3FYpgPA",
        "9K0803PA",
        "b10O9yPA",
        "VLJbUmPA",
        "CkwTH2PA",
        "xvlRJxPA",
        "CR9CDIPA",
        "2JDZ0hPA",
        "4nITk2PA",
        "WXNGlFPA",
        "RZ86J4PA",
        "wTI5AfPA",
        "NqTEl9PA",
        "oFEzOgPA",
        "o6SoG8PA",
        "pCPmlfPA",
        "p4esl0PA",
        "iKaGpsPA",
        "zlHKMBPA",
        "nXCKRwPA",
        "SFewjrPA",
        "opFLpfPA",
        "Mwj1iHPA",
        "TRP5zHPA",
        "pD8nLIPA",
        "tuZ4qAPA",
        "N1M33tPA",
        "l0r8WdPA",
        "XsITOPPA",
        "xlQPPePA",
        "shlVMHPA",
        "y9PPo9PA",
        "d1wNqWPA",
        "I4hRfZPA",
        "liT2hwPA",
        "g2J7xQPA",
        "VBZ93IPA",
        "xMfdllPA",
        "fsDqmLPA",
        "ssfO0pPA",
        "dpWyl3PA",
        "LDUfzyPA",
        "1vEZjmPA",
        "oreiyKPA",
        "GglOonPA",
        "JoL2MsPA",
        "8gDDIDPA",
        "kterSxPA",
    ],
    // The exception for channels with channel_origin == integrated_onboarding to
    // allow API key creation for all clients from those partners
    ApiKeyCreationException: [
        "SvAiK8PA",
        "1HrOdjPA",
        "CmfFRDPA",
        "3A99H5PA",
        "Qlvm1vPA",
        "KJNS6kPA",
        "sJrUixPA",
        "vXfVgrPA",
        "uFLRmmPA",
        "rHwLIGPA",
        "srMmqpPA",
        "aUjlH3PA",
        "zW8CroPA",
        "bRVwbQPA",
        "DPiM0ePA",
        "zH3MuZPA",
        "rthyxaPA",
        "7iMepZPA", // Staging
    ],
    termsOfServiceChangeClients: ["SiSRfl8UCL"],
    termsOfServiceChangePrice: [
        "CmfFRDPA",
        "1HrOdjPA",
        "CON5A9PA",
        "9K0803PA",
        "5urmEBPA",
        "8gDDIDPA",
        "J23j2RPA",
        "jaGVLbPA",
        "5Zxli7PA",
        "plHwVcPA",
        "1QcGcbPA",
        "U5ylW4PA",
        "iDtgTpPA",
        "1nkEWWPA",
        "FGnmxgPA",
        "oHk40EPA",
        "drCSjPPA",
        "oWSmVePA",
        "pHWbSuPA",
        "wYhOWPPA",
        "nGW3H5PA",
        "VFZMpTPA",
        "5ILQfnPA",
        "2JDZ0hPA",
        "0SATWQPA",
        "Nk9MhxPA",
        "1OyuqDPA",
        "ickmk2PA",
        "V3wc38PA",
        "wTI5AfPA",
        "vNKb61PA",
        "HJI1ukPA",
        "UfdIklPA",
        "b8VYoNPA",
        "cpabddPA",
        "CkwTH2PA",
        "FUEVMZPA",
        "V01LKzPA",
        "7KFk99PA",
        "7uqptQPA",
        "nBXc8NPA",
        "DuaBzFPA",
        "0SATWQPA",
        "cdmBraPA",
        "S9JSliPA",
        "frnlL3PA",
        "U5oxSgPA",
        "UUSd78PA",
        "wYZlu3PA",
        "LcgcDgPA",
        "QmijZ1PA",
        "Tyon7vPA",
        "PO2HtNPA",
        "5q8SI2PA",
        "jbVmnNPA",
        "I9RpMZPA",
        "Tuk0tFPA",
        "Nog49UPA",
        "t94o8DPA",
        "iQ2lAcPA",
        "LidShFPA",
        "3CMcwYPA",
        "EWcCEUPA",
        "8CMkNlPA",
        "asb2XQPA",
        "w7Z5nNPA",
        "0Ik4qPPA",
        "jDnvuYPA",
        "QKlWYqPA",
        "5lzSJ0PA",
        "eUixdSPA",
        "ATh3hUPA",
        "xNdKcOPA",
        "VodnR5PA",
        "cn5kgIPA",
        "pCPmlfPA",
        "OM9IrxPA",
        "DwXAvePA",
        "5qfJixPA",
        "sQAkg8PA",
        "N8q9EFPA",
        "UcQf2VPA",
        "4NY7sTPA",
        "jDSCbJPA",
        "77r6XBPA",
        "MJx5NwPA",
        "Ae8hq5PA",
        "CXN8ODPA",
        "WDNbKFPA",
        "peRGSUPA",
        "LCUQz9PA",
        "yBmEt2PA",
        "9fIvC4PA",
        "KxcNS7PA",
        "e9OaQsPA",
        "pD8nLIPA",
        "ViA3IhPA",
        "s0CbwUPA",
        "eNecjTPA",
        "nzFZKvPA",
        "JJu1XbPA",
        "4xX6E3PA",
        "YZKzG7PA",
        "MTRBnQPA",
        "xDWnSlPA",
        "pHWbSuPA",
        "mkeCXZPA",
        "8L0NNEPA",
        "0CtDDtPA",
        "lKxjPkPA",
        "1QcGcbPA",
        "0987HrPA",
        "eO730iPA",
        "BmrWFkPA",
        "2oDwvBPA",
        "yiuFCXPA",
        "8YRoKCPA",
        "z19ri4PA",
        "4dltmxPA",
        "1CgA4FPA",
        "shlVMHPA",
        "1BPuMGPA",
        "M40cXvPA",
        "Uqh15pPA",
        "G40NnoPA",
        "26X9QPPA",
        "mns6ydPA",
        "B8NmtTPA",
        "JDv0gHPA",
        "GbM78BPA",
        "k3lDmcPA",
        "R7pQBwPA",
        "rKRgFhPA",
        "9kjcsoPA",
        "ugljugPA",
        "VCaZWVPA",
        "ImXEZUPA",
        "HuYlBjPA",
        "u9dvjmPA",
        "bMGHlGPA",
        "SdMAwIPA",
        "r27bNVPA",
        "F3mkXAPA",
        "U5ylW4PA",
        "AAZ3tjPA",
        "2a8R7pPA",
        "AvqxdnPA",
        "Hni0ZUPA",
        "pT9WWHPA",
        "VmXxJWPA",
        "PaXUqtPA",
        "hOCitlPA",
        "kzFR9DPA",
        "tM9FDiPA",
        "liT2hwPA",
        "W6J7cMPA",
        "QO58gYPA",
        "iMS52vPA",
        "6sgnqXPA",
        "DEu8nqPA",
        "wrZvmxPA",
        "JA8P1JPA",
        "iDtgTpPA",
        "eyRcptPA",
        "d02wePPA",
        "1k3ILcPA",
        "e6BuouPA",
        "05afB5PA",
        "yhkzyzPA",
        "1sA3v9PA",
        "3HZxnWPA",
        "VFZMpTPA",
        "M9VF9oPA",
        "Dhc25rPA",
        "UtWzZIPA",
        "I7dM2NPA",
        "tjYdNWPA",
        "GPhxtfPA",
        "Cs3fYCPA",
        "IxVvcPPA",
        "CajhtNPA",
        "I7aqisPA",
        "xKwILbPA",
        "bRVwbQPA",
        "dkazb1PA",
        "Fn9N04PA",
        "qJdYgpPA",
        "VGHIrdPA",
        "p177cCPA",
        "9AZKtqPA",
        "oUrhKTPA",
        "O4srjnPA",
        "eqQMCmPA",
        "MgNp5yPA",
        "3yKNlwPA",
        "54HwsZPA",
        "xAm2nuPA",
        "XuWWScPA",
        "ZKxY1sPA",
        "okLnSDPA",
        "o2i3WVPA",
        "X5UJ0vPA",
        "ZLuciFPA",
        "Su2jLXPA",
        "xvlRJxPA",
        "YwFvEtPA",
        "EJNmOQPA",
        "obP7p4PA",
        "ByX4OePA",
        "GtTuOJPA",
        "05beyYPA",
        "42Bx7lPA",
        "BXPrc4PA",
        "ESGxeWPA",
        "mBGvPpPA",
        "logQkUPA",
        "LE3RwUPA",
        "UUSd78PA",
        "4xX6E3PA",
        "aCJ5WrPA",
        "zaw6lZPA",
        "oWSmVePA",
    ],
    noToSPopupPartners: [
        "hMc1kKPA",
        "rrS87mPA",
    ]
};
export var useAllowlistCheck = function (feature, id, noAcl) {
    if (allowlists[feature]) {
        if (id)
            return allowlists[feature].includes(id);
        if (!noAcl) {
            var partnerId = useAcl().partnerId;
            return partnerId ? allowlists[feature].includes(partnerId) : false;
        }
    }
    return false;
};
export var useAllowlistCheckUrl = function (feature, url) {
    if (allowlists[feature])
        return allowlists[feature].some(function (element) { return url.includes(element); });
    return false;
};
//# sourceMappingURL=data:application/json;base64,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